'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactScroll = require('react-scroll');

var Scroll = _interopRequireWildcard(_reactScroll);

var _smoothscrollPolyfill = require('smoothscroll-polyfill');

var _smoothscrollPolyfill2 = _interopRequireDefault(_smoothscrollPolyfill);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var lastScrollTop = 0;

var CategoryMenu = function (_Component) {
    _inherits(CategoryMenu, _Component);

    function CategoryMenu(props) {
        _classCallCheck(this, CategoryMenu);

        var _this = _possibleConstructorReturn(this, (CategoryMenu.__proto__ || Object.getPrototypeOf(CategoryMenu)).call(this, props));

        _this.scrollToCategory = function (id, index) {

            // Check if the user agent contains "iPad" and "Safari"
            // let isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
            var isIpad = navigator.userAgent.match(/iPad/i) != null;

            // If we found the different default selected group then update the defaultIndex state
            // Based on the parental group we will update the sub groups
            // if (this.state.defaultIndex != index && this.state.isBrowser){
            if (_this.state.defaultIndex != index) {
                // set the parental group index and get sub-groups based on the selected parental index
                // Check how we can do without updating the index
                _this.setState({
                    defaultIndex: index
                });
            }

            if (_this[id].current && isIpad == false) {
                _this[id].current.scrollIntoView({ block: "nearest", inline: "center" });
            }
        };

        _this.scrollToSubCategory = function (id) {
            // Check if the user agent contains "iPad" and "Safari"
            // let isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
            var isIpad = navigator.userAgent.match(/iPad/i) != null;

            if (_this[id].current && isIpad == false) {
                _this[id].current.scrollIntoView({ block: "nearest", inline: "center" });
            }
        };

        _this.state = {
            categoryData: [],
            defaultIndex: 0,
            subCategoryData: [],
            isScrollTop: false,
            showPreviousButton: false,
            isMenuMobileView: false,
            expandSearchBar: false,
            top: 0,
            changeWebView: false,
            isBrowser: false

        };

        _this.selectorRef = _react2.default.createRef(null);
        _this.defaultIndex = _react2.default.createRef();
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);

        return _this;
    }

    _createClass(CategoryMenu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var width = window.innerWidth;
            var browserView = width > 993 ? true : false;

            this.setState({
                categoryData: this.props.categoryData,
                isBrowser: browserView
            }, function () {
                _this2.setDefaultCategoryMenu();
            });

            var categoryData = this.props.categoryData || [];

            categoryData.forEach(function (group) {

                var subGroups = group.subGroups || [];

                // let groupId   = `${group.groupName.trim().replace(/[^A-Z0-9]+/ig, "_")}`;
                // this[groupId] = React.createRef();

                var groupId = '' + group.groupName.trim().replace(/[^A-Z0-9]+/ig, "_");
                _this2[groupId] = _react2.default.createRef();

                subGroups.map(function (subGroup, id) {

                    var parentalAndSub = group.groupName + "_" + subGroup;
                    var subGroupId = parentalAndSub.trim().replace(/[^A-Z0-9]+/ig, "_");
                    _this2[subGroupId] = _react2.default.createRef();
                });
            });

            _reactScroll.scrollSpy.update();

            // kick off the polyfill!
            _smoothscrollPolyfill2.default.polyfill();

            window.addEventListener('scroll', this.handleScroll);
            //add resize browser window listener
            window.addEventListener("resize", this.updateWindowDimensions);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this3 = this;

            // wrong logic updated
            // need to check after the change location if it is correct or not
            if (this.state.categoryData !== nextProps.categoryData) {

                var categoryData = nextProps.categoryData || [];

                categoryData.forEach(function (group) {

                    var subGroups = group.subGroups || [];

                    // let groupId   = `${group.groupName.trim().replace(/[^A-Z0-9]+/ig, "_")}`;
                    // this[groupId] = React.createRef();

                    var groupId = '' + group.groupName.trim().replace(/[^A-Z0-9]+/ig, "_");
                    _this3[groupId] = _react2.default.createRef();

                    subGroups.map(function (subGroup, id) {

                        var parentalAndSub = group.groupName + "_" + subGroup;
                        var subGroupId = parentalAndSub.trim().replace(/[^A-Z0-9]+/ig, "_");
                        _this3[subGroupId] = _react2.default.createRef();
                    });
                });

                this.setState({
                    categoryData: nextProps.categoryData
                }, function () {
                    _this3.setDefaultCategoryMenu();
                });

                _reactScroll.scrollSpy.update();
            }
        }
    }, {
        key: 'updateWindowDimensions',
        value: function updateWindowDimensions() {

            var width = window.innerWidth;

            this.setState({
                isBrowser: width > 993 ? true : false
            });
        }
    }, {
        key: 'setDefaultCategoryMenu',
        value: function setDefaultCategoryMenu() {
            var categoryData = this.state.categoryData || [];

            if (categoryData && categoryData[0] && categoryData[0].subGroups) {

                var elem1 = document.getElementById("parental-ui-scroll");
                var elem2 = document.getElementById("sub-parental-ui-scroll");

                //check elem exists on node
                if (elem1) {
                    var elem1ChildNode = document.getElementById("parental-ui-scroll").childNodes[0];

                    if (elem1ChildNode) {
                        elem1ChildNode.childNodes[0].className = "nav-link parental-nav-link nav-link-active";
                    }
                }

                //check elem exists on node
                if (elem2) {
                    var elem2ChildNode = document.getElementById("sub-parental-ui-scroll").childNodes[0];

                    if (elem2ChildNode) {
                        elem2ChildNode.childNodes[0].className = "sub-parent-nav-link sub-parent-active";
                    }
                }
            } else {
                var elem3 = document.getElementById("pills-tab");

                //check elem exists on node
                if (elem3) {
                    var elem3ChildNode = document.getElementById("pills-tab").childNodes[0];

                    if (elem3ChildNode) {
                        elem3ChildNode.childNodes[0].className = "sub-parent-nav-link sub-parent-active";
                    }
                }
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e) {

            var navBar = document.getElementById("navBarTop");
            var menuPos = document.getElementById("menuPos");
            var stickyBox = document.getElementById("sticky-box");
            var window = e.currentTarget;
            var oldScrollY = window.scrollY;
            var isBrowser = this.state.isBrowser;
            var scrollPos = !isBrowser ? 291 : 351;
            var oldScroll = 0;

            var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

            if (window.scrollY == 0 || window.scrollY <= 250) {
                // show first category or sub category selected
                this.setDefaultCategoryMenu();
            }

            if (isBrowser) {
                // Web View

                if (window.scrollY <= scrollPos) {

                    // use the div id and set display block and display none
                    this.setState({
                        changeWebView: false
                    });
                } else {
                    this.setState({
                        changeWebView: true
                    });
                }
            } else {

                // Mobile View
                if (st > lastScrollTop) {
                    // downscroll code
                    navBar.classList.add("nav-animate-down");
                    navBar.classList.remove("nav-animate-up");
                    navBar.classList.add("collapsed");

                    stickyBox.classList.add("menu-animate-down");
                    stickyBox.classList.remove("menu-animate-up");
                    stickyBox.style.top = 0;
                } else if (st < lastScrollTop) {
                    // Scroll Up
                    navBar.classList.add("nav-animate-up");
                    navBar.classList.remove("nav-animate-down");
                    navBar.classList.remove("collapsed");

                    stickyBox.classList.remove("menu-animate-down");
                    stickyBox.classList.add("menu-animate-up");
                    stickyBox.style.top = "63px";
                }
            }

            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // Events.scrollEvent.remove('begin');
            // Events.scrollEvent.remove('end');
            window.removeEventListener('scroll', this.handleScroll);
            //remove resize browser window listener
            window.removeEventListener("resize", this.updateWindowDimensions);
        }
    }, {
        key: 'getParentalDropdownMenu',
        value: function getParentalDropdownMenu() {
            var _this4 = this;

            var categoryData = this.state.categoryData || [];

            var groupName = "";
            if (categoryData && categoryData[0] && categoryData[0].subGroups) {

                // get the selected group from parental based on the index
                var selectedGroup = categoryData[this.state.defaultIndex];
                groupName = selectedGroup.groupName;

                return _react2.default.createElement(
                    'div',
                    { className: 'parental-dropdown animate parental-box' },
                    _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn btn-sm dropdown-toggle btn-parental-dropdown position-relative', 'data-toggle': 'dropdown', 'aria-haspopup': 'true', 'aria-expanded': 'false', tabIndex: 8 },
                        groupName
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown-menu' },
                        categoryData.map(function (group, idx) {
                            var component = null;
                            var groupId = '' + group.groupName.trim().replace(/[^A-Z0-9]+/ig, "_");

                            // component =  (
                            //     <a className="dropdown-item" href="#" key={idx}>{group.groupName}</a>
                            // );

                            component = _react2.default.createElement(
                                _reactScroll.Link,
                                {
                                    key: groupId + idx,
                                    activeClass: 'sub-parent-active',
                                    className: "dropdown-item",
                                    to: groupId.toString(),
                                    spy: true,
                                    smooth: true
                                    // hashSpy={true}
                                    , duration: 600,
                                    offset: -250
                                    // delay={1000}
                                    , onSetActive: function onSetActive() {
                                        return _this4.scrollToCategory(groupId, idx);
                                    },
                                    href: '#',
                                    onClick: function onClick(event) {
                                        return event.preventDefault();
                                    },
                                    tabIndex: 9
                                    // data-toggle="pill"
                                    // role="tab"
                                    // aria-controls="pills-order-online"
                                    // aria-selected="false"
                                },
                                group.groupName
                            );
                            return component;
                        })
                    ),
                    _react2.default.createElement('div', { className: "border-separator" })
                );
            } else {
                return null;
            }
        }
    }, {
        key: 'getMenuComponent',
        value: function getMenuComponent() {
            var _this5 = this;

            var categoryData = this.state.categoryData || [];

            // check the subGroups available or not in the menu then set the margin based on the subGroups
            // Parental Menu
            if (categoryData && categoryData[0] && categoryData[0].subGroups) {

                // get the selected group from parental based on the index
                var selectedGroup = categoryData[this.state.defaultIndex];
                // let parentGroupId   = `${selectedGroup.groupName.trim().replace(/[^A-Z0-9]+/ig, "_")}`;
                var subGroups = selectedGroup.subGroups;

                return _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        !this.state.changeWebView ? _react2.default.createElement(
                            'div',
                            { className: 'col-md-12' },
                            _react2.default.createElement(
                                'ul',
                                { className: 'nav parental-ul', id: 'parental-ui-scroll', role: 'tablist' },
                                categoryData.map(function (group, idx) {
                                    var groupId = '' + group.groupName.trim().replace(/[^A-Z0-9]+/ig, "_");
                                    return _react2.default.createElement(
                                        'li',
                                        { className: 'nav-item',
                                            id: groupId,
                                            key: groupId + idx,
                                            ref: _this5[groupId]
                                        },
                                        _react2.default.createElement(
                                            _reactScroll.Link,
                                            {
                                                id: "parental_menu_" + groupId,
                                                activeClass: 'nav-link-active',
                                                className: "nav-link parental-nav-link",
                                                to: groupId.toString(),
                                                spy: true,
                                                smooth: true
                                                // hashSpy={true}
                                                , duration: 600,
                                                offset: -250
                                                // delay={1000}
                                                , onSetActive: function onSetActive() {
                                                    return _this5.scrollToCategory(groupId, idx);
                                                },
                                                href: '#',
                                                onClick: function onClick(event) {
                                                    return event.preventDefault();
                                                },
                                                tabIndex: 8
                                            },
                                            group.groupName
                                        )
                                    );
                                })
                            )
                        ) : null,
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-12' },
                            this.state.changeWebView ? this.getParentalDropdownMenu() : null,
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'nav parental-ul', id: 'sub-parental-ui-scroll', role: 'tablist' },
                                    subGroups.map(function (subGroup, id) {

                                        var parentalAndSub = selectedGroup.groupName + "_" + subGroup;
                                        var subGroupId = parentalAndSub.trim().replace(/[^A-Z0-9]+/ig, "_");

                                        return _react2.default.createElement(
                                            'li',
                                            { className: 'sub-parent-nav-item',
                                                id: subGroupId,
                                                key: subGroupId + id,
                                                ref: _this5[subGroupId]
                                            },
                                            _react2.default.createElement(
                                                _reactScroll.Link,
                                                {
                                                    id: "a_" + subGroupId,
                                                    activeClass: 'sub-parent-active',
                                                    className: "sub-parent-nav-link",
                                                    to: subGroupId,
                                                    spy: true,
                                                    smooth: true
                                                    // hashSpy={true}
                                                    , duration: 600,
                                                    offset: -287,
                                                    onSetActive: function onSetActive() {
                                                        return _this5.scrollToSubCategory(subGroupId);
                                                    },
                                                    href: '#',
                                                    onClick: function onClick(event) {
                                                        return event.preventDefault();
                                                    },
                                                    tabIndex: 9
                                                },
                                                subGroup
                                            )
                                        );
                                    })
                                )
                            )
                        )
                    )
                );
            } else {
                // Not Parental
                return _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-12' },
                            _react2.default.createElement(
                                'ul',
                                { className: 'nav parental-ul', id: 'pills-tab', role: 'tablist' },
                                categoryData.map(function (group, id) {
                                    var groupId = '' + group.groupName.trim().replace(/[^A-Z0-9]+/ig, "_");
                                    return _react2.default.createElement(
                                        'li',
                                        { className: 'sub-parent-nav-item',
                                            id: groupId,
                                            key: groupId + id,
                                            ref: _this5[groupId]
                                        },
                                        _react2.default.createElement(
                                            _reactScroll.Link,
                                            {
                                                id: "a_" + groupId,
                                                activeClass: 'sub-parent-active',
                                                className: 'sub-parent-nav-link',
                                                to: groupId,
                                                spy: true,
                                                smooth: true,
                                                duration: 600,
                                                offset: -280,
                                                onSetActive: function onSetActive() {
                                                    return _this5.scrollToSubCategory(groupId);
                                                },
                                                href: '#',
                                                onClick: function onClick(event) {
                                                    return event.preventDefault();
                                                },
                                                tabIndex: 9
                                            },
                                            group.groupName
                                        )
                                    );
                                })
                            )
                        )
                    )
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { id: "sticky-box", className: 'sticky-box-container' },
                    _react2.default.createElement(
                        'section',
                        { className: 'offer-dedicated-nav bg-white border-top-0 shadow-sm position-relative', id: 'menuPos' },
                        _react2.default.createElement(
                            'div',
                            { className: 'container' },
                            this.getMenuComponent()
                        )
                    )
                )
            );
        }
    }]);

    return CategoryMenu;
}(_react.Component);

exports.default = CategoryMenu;


//////////////////
// WEBPACK FOOTER
// ./src/components/CategoryMenu.jsx
// module id = 419
// module chunks = 0